import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/jenkins/workspace/Umbrella_Umbrella_Frontend_prod/node_modules/@ant-design/nextjs-registry/es/AntdRegistry.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/jenkins/workspace/Umbrella_Umbrella_Frontend_prod/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["AntdProvider"] */ "/var/lib/jenkins/workspace/Umbrella_Umbrella_Frontend_prod/src/app/core/AntdProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppProvider"] */ "/var/lib/jenkins/workspace/Umbrella_Umbrella_Frontend_prod/src/app/core/AppContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/jenkins/workspace/Umbrella_Umbrella_Frontend_prod/src/app/core/MainLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SessionExpiredModal"] */ "/var/lib/jenkins/workspace/Umbrella_Umbrella_Frontend_prod/src/components/SessionExpiredModal.tsx");
;
import(/* webpackMode: "eager" */ "/var/lib/jenkins/workspace/Umbrella_Umbrella_Frontend_prod/src/styles/main.scss");
;
import(/* webpackMode: "eager" */ "/var/lib/jenkins/workspace/Umbrella_Umbrella_Frontend_prod/src/styles/icons.scss");
